import { useEffect, useState } from "react";
import { SITE } from "@/config/site";
import { BookButton } from "@/components/GoldButton";
import { scrollToId, scrollToTop } from "@/lib/scroll";

const LINKS = [
  ["Experience", "#experience"],
  ["Highlights", "#highlights"],
  ["Artists", "#artists"],
  ["Details", "#details"],
  ["Tickets", "#tickets"],
  ["Venue", "#venue"],
  ["FAQ", "#faq"],
];

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-40 transition-[background-color,border-color] duration-500 ${
        scrolled
          ? "border-b border-[#D4AF37]/20 bg-[#080705]/85 backdrop-blur-md"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
        <a
          href="/"
          data-testid="nav-home-link"
          aria-label="Chitti Ayee Hai — back to top"
          onClick={(e) => {
            e.preventDefault();
            scrollToTop();
          }}
          className="flex items-center"
        >
          <img
            src={SITE.brand.logoSmall}
            alt={SITE.brand.logoAlt}
            data-testid="nav-logo"
            className="h-12 w-auto sm:h-14"
          />
        </a>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary">
          {LINKS.map(([label, id]) => (
            <a
              key={id}
              href={id}
              data-testid={`nav-${label.toLowerCase()}-link`}
              onClick={(e) => {
                e.preventDefault();
                scrollToId(id);
              }}
              className="nav-link text-sm font-semibold uppercase tracking-[0.16em] text-[#C8C2B7] transition-colors duration-300 hover:text-[#E6CA65]"
            >
              {label}
            </a>
          ))}
        </nav>

        <BookButton location="nav" size="sm" testId="nav-book-tickets-btn" />
      </div>
    </header>
  );
}
